
import React, { ErrorInfo } from 'react';
import LayoutErrorApp from '../layouts/layoutErrorApp/layoutErrorApp';

interface IErrorBoundaryAppProps {
  children: React.ReactNode;
}

interface IErrorBoundaryAppState {
  hasError: boolean;
}

class ErrorBoundaryApp extends React.Component<IErrorBoundaryAppProps, IErrorBoundaryAppState> {
  constructor(props: IErrorBoundaryAppProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // You can also log the error to an error reporting service
    console.error('Uncaught error:', error, errorInfo);
  }

  handleReload = () => {
    // Reload the App by forcing a re-render.
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) return (<LayoutErrorApp />);

    return this.props.children;
  }
}

export function withErrorBoundaryApp<T extends React.PropsWithChildren<{}>>(WrappedComponent: React.ComponentType<T>, errorBoundaryProps: Omit<IErrorBoundaryAppProps, 'children'> = {}) {
  return function ErrorBoundaryWithErrorBoundary(props: T) {
    return (
      <ErrorBoundaryApp {...errorBoundaryProps}>
        <WrappedComponent {...props} />
      </ErrorBoundaryApp>
    );
  };
}

export default ErrorBoundaryApp;